import React from 'react';
import { Reveal } from './Reveal';
import { CountUp } from './CountUp';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const AchievementsSection: React.FC = () => {
  const { achievements } = useContent();

  return (
    <section id="inhouse">
      <div className="section-head">
        <div>
          <div className="eyebrow">{achievements.eyebrow}</div>
          <h2
            className="display-h2"
            style={{ marginTop: 14 }}
            dangerouslySetInnerHTML={{ __html: achievements.headingHtml }}
          />
        </div>
      </div>

      <div className="ea-wrap">
        <Reveal className="ea-main glass">
          <div className="ea-brand">{achievements.brand}</div>
          <h3>{achievements.mainHeading}</h3>
          <ul>
            {achievements.bullets.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
        </Reveal>

        <div className="ea-side">
          {achievements.stats.map((stat, i) => (
            <Reveal key={stat.label} delay={80 + i * 60} className="ea-stat glass-soft">
              <div className="num">
                {stat.value !== undefined ? (
                  <CountUp value={stat.value} suffix={stat.suffix} />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: stat.numHtml ?? '' }} />
                )}
              </div>
              <div className="lbl">{stat.label}</div>
              <p>{stat.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
